import React from 'react'

import { CheckBox, CheckBoxOutlineBlankRounded, RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material'

export default class CheckboxListItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      opacity: 1,
    }
  }
  
render(){
  const Comp = this.props.checked ? (this.props.radio ? RadioButtonChecked : CheckBox) : (this.props.radio ? RadioButtonUnchecked : CheckBoxOutlineBlankRounded)
  return(
    <div style={{
      ...this.props.style,
      cursor: 'pointer',
      height: this.props.big ? '40px' : '26px',
      padding: '0px 8px',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderBottom: !this.props.noBorder ? 'thin solid #EEE' : 'none',
      // backgroundColor: 'yellow',
      display: 'flex',
      opacity: this.props.radio ? 1 : this.state.opacity,
      whiteSpace: 'nowrap',
      userSelect: 'none',
      // transition: 'opacity 300ms ease',
    }}
    // onClick = {() => {
    //   this.props.onPress(this.props.index)
    // }}
      onMouseDown={() => this.setState({opacity: 0.75})}
      onMouseOut={() => this.setState({opacity: 1})}
      onMouseUp={() => {
        this.setState({opacity: 1})
        this.props.onPress(this.props.index)
      }
    }
    >
      <Comp style={{
        // color: '#bd0404',
        color: '#F4868D',
        fontSize: 22,
        marginRight: '6px',
        // flex: 1,
      }}
      />
        {this.props.title}
          
        
          {/*<div style={{
            fontStyle: 'italic',
            fontSize: '10pt',
            paddingLeft: '8px',
          }}>
          {this.props.ownerName}
          </div>
        */}
          
    </div>
)
  }
}
